module.exports = __webpack_public_path__ + "static/media/025-anguilla.b134a401.svg";